// extracted by mini-css-extract-plugin
export default {"wrapper":"_1-z","play":"a2-z"};